import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=53c02178&scoped=true"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=53c02178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c02178",
  null
  
)

export default component.exports